import { PropsWithChildren, SVGProps } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { AlertSnackbar, Badge, Divider, Headline, IconButton, Link } from 'components'

import { combineClassnames } from '../combineClassnames'
import { ArrowLeftIcon } from '../icons'
import styles from './PageHeader.module.scss'

interface PageHeaderProps extends PropsWithChildren {
  badge?: number | string
  badgeClassName?: string
  className?: string
  description?: string
  docu?: string
  hasBack?: boolean
  hasDivider?: boolean
  icon?: React.FC<SVGProps<SVGSVGElement>>
  title: string
}
const PageHeader = ({
  badge,
  badgeClassName,
  children,
  className,
  description,
  docu,
  hasBack = false,
  hasDivider = false,
  icon: Icon,
  title,
}: PageHeaderProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation('components')

  return (
    <div className={[styles.pageHeaderContainer, className].join(' ')}>
      <div className={styles.pageHeader}>
        <div>
          <div>
            <div
              className={combineClassnames(
                styles.pageHeadlineContainer,
                badge && typeof badge === 'string' ? styles.textBadge : undefined,
              )}
            >
              {Icon && (
                <div className={styles.icon}>
                  <Icon />
                </div>
              )}
              <div className={styles.pageHeadline}>
                {hasBack && (
                  <IconButton
                    className={styles.back}
                    icon={ArrowLeftIcon}
                    onClick={() => void navigate(-1)}
                    small
                    variant="tertiary"
                  />
                )}
                <Headline className={styles.headline}>{title}</Headline>
              </div>
              {badge &&
                (typeof badge === 'string' ? (
                  <AlertSnackbar className={badgeClassName} text={badge} />
                ) : (
                  <Badge value={badge} />
                ))}
            </div>
            {children}
          </div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
        {docu && <Link title={t('pageHeader.docu')} to={docu} />}
      </div>
      {hasDivider && <Divider className={styles.divider} />}
    </div>
  )
}

export default PageHeader
